/** @module */
import { AbstractPageNumberList } from './abstract-page-number-list';


/**
 * A list with page number pagination.
 * @see {@link abstract-page-number-list.md} for inherited API.
 * @class
 */
export class PageNumberList extends AbstractPageNumberList {}
